<template>
  <div class="container">

    <div class="handle-box-search">
      <div class="handle-box">




        <el-row style="margin-bottom: 10px;">
          <el-col :span="24">
            <span class="title">司机昵称:</span>

            <el-input v-model="search_data.name" style="width: 200px;"></el-input>
          </el-col>
        </el-row>



        <el-row type="flex" justify="space-between">

          <el-col :span="22">
            <el-button type="primary" icon="el-icon-search" @click="getdriverStatistics" style="padding: 6px 12px;">搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="refresh" style="padding: 6px 12px;">重置
            </el-button>
          </el-col>




        </el-row>

      </div>

    </div>

    <div class="charts-box">

      <div id="timeCharts" style="width: 100%;height: 400px;"></div>

    </div>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>



  </div>

</template>

<script>
  var _this;
  import echarts from 'echarts'
  export default {
    data() {
      return {



        reg_time_value: '',
        reg_time_array: [],

        company_name: '',



        timeCharts: '',
        timeOption: {
          title: {
            text: '司机在线时长',
            subtext: ''
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['总在线时长(分钟)', '今日线时长(分钟)']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: []
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          series: [{
              name: '总在线时长(分钟)',
              type: 'bar',
              data: []
            },
            {
              name: '今日线时长(分钟)',
              type: 'bar',
              data: []
            }
          ]
        },




        search_data: {
          page: 1,
          limit: 10,
          name: ''
        },


        result_data: [],

      };
    },
    created() {
      _this = this;

      _this.getdriverStatistics();
    },
    mounted() {

      _this.echartsInit()

    },
    methods: {



      echartsInit() {

        this.timeCharts = echarts.init(document.getElementById('timeCharts'))
        this.timeCharts.setOption(_this.timeOption)




      },




      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.getdriverStatistics();

      },


      getdriverStatistics() {

        _this.timeOption.xAxis.data = [];

        _this.timeOption.series[0].data = [];

        _this.timeOption.series[1].data = [];

        _this.$post(
            "/statistics/driverDriverStatusLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            _this.result_data = res;


            for (let i = 0; i < res.data.length; i++) {

              _this.timeOption.xAxis.data.push(res.data[i].name)

              _this.timeOption.series[0].data.push(Math.floor(res.data[i].online_time / 60))

              _this.timeOption.series[1].data.push(Math.floor(res.data[i].today_online_time / 60))

            }


            _this.echartsInit();


          }).catch((err) => {

          })
      },

      // 搜索预约时间触发
      regTimeChange(val) {
        _this.reg_time_array = [];

        _this.search_data.reg_time_array = [];
        if (val == 'between') {

          _this.search_data.reg_time_array.push(_this.reg_time_value);

        } else if (val == '') {


        } else {

          _this.search_data.reg_time_array.push(_this.reg_time_value);

          _this.search_data.reg_time_array = JSON.stringify(_this.search_data.reg_time_array);
        }

      },

      // 搜索时间选择触发
      timeChange() {


        _this.search_data.reg_time_array.push(_this.reg_time_array[0]);
        _this.search_data.reg_time_array.push(_this.reg_time_array[1]);

        _this.search_data.reg_time_array = JSON.stringify(_this.search_data.reg_time_array);


      },




      // 重置按钮
      refresh() {
        _this.search_data = {
          page: 1,
          limit: 10,
          name: ''
        }
      },

    }
  };
</script>

<style scoped>
  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }

  .table-head {
    margin-bottom: 20px;
  }


  .title {
    display: block;
    width: 100px;
    padding-right: 16px;
    text-align: right;
    box-sizing: border-box;
    color: #606266;
    height: 28px;
    line-height: 28px;
    float: left;
  }

  .table-head-search {
    display: flex;
    justify-content: space-between;
  }

  .table-head .search-radio {
    width: 100%;
  }

  .container-tabs .el-tabs__item.is-top.is-active {
    border: 1px solid #dcdfe6;
  }

  .charts-box {
    display: flex;

  }
</style>
<style>
  .table-head-search .el-select.el-select--small,
  .table-head .el-radio-group {
    width: calc(100% - 100px);
  }

  .table-head-search .el-select.el-select--small .el-input.el-input--small.el-input--suffix {
    width: 100% !important;
  }

  .table-head>div .el-input--small {
    width: calc(100% - 100px);

    float: left;
  }



  .table-head>div .el-input--small .el-input__inner {
    height: 28px;
    line-height: 28px;

  }

  .container .el-tabs__header {
    margin-bottom: 0 !important;
  }

  .table-head .el-checkbox__inner {
    display: none;
  }

  .table-head .el-radio__inner {
    display: none;
  }

  .table-head .el-checkbox-group {
    display: inline-block;
  }

  .table-head .el-checkbox,
  .table-head .el-radio {
    border: 0px solid transparent;
    background-color: transparent;
    border-radius: 5px !important;
  }

  .table-head .el-checkbox.is-checked,
  .table-head .el-radio.is-checked {
    border: 0px solid #409EFF;
    /* background-color: #ecf5ff;  */
  }

  .table-head .el-checkbox__label,
  .table-head .el-radio__label {
    padding: 0;
  }




  .container-tabs .el-tabs__nav.is-top {
    border: 0;
  }

  .container-tabs .el-tabs__item.is-top {
    border: 1px solid transparent;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .container-tabs .el-tabs__header.is-top {
    border-bottom: 0;
  }

  .el-col.el-col-6>span {
    display: inline-block;
    width: 100px;
    text-align: left;
  }

  .sub #tab-new .table-title {
    color: #65c138;
  }

  .sub #tab-proceed .table-title {
    color: #b6ae3a;
  }

  .sub #tab-serving .table-title {
    color: #409eff;
  }

  .sub #tab-unpaid .table-title {
    color: #f67745;
  }

  .sub #tab-paid .table-title {
    color: #606266;
  }

  .sub #tab-order_cancel .table-title {
    color: #606266;
  }

  .order-table-lists .el-table__body .cell {
    color: #000;
    font-weight: 500;
    font-size: 18px;
  }

  .el-date-range-picker__time-header {
    display: block;
  }
</style>